import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { Menu } from '@material-ui/icons';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import { persistStore } from 'aurora-composition/actions/auroraUiActions';
import { fetchTask } from 'aurora-composition/modules/tasks/actions';
import { CleverTapHeaderHelp, CleverTapNavigation } from 'aurora-utils/cleverTap.eventhelper';
import dummy from 'aurora-api/dummy/dummyContents';
import appContent from 'aurora-api/dummy/appContent';
import link from 'aurora-api/ui/link';
import { ADGMImage, LightTooltipComponent } from 'aurora-components';
// import helpIcon from 'aurora-images/helpicon.svg';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import Container from '@material-ui/core/Container';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { FRESH_DESK_URL, MAINTANANCE_MODE } from 'aurora-utils/constants';
import TaskList from './TasksList';
import MoreMenu from './MoreMenu';

// import SelectLanguage from '../SelectLanguage';
import SidebarContent from '../Sidebar/SidebarContent';
import Navigation from './Navigation';
import UserMenu from './UserMenu';
// import ADGMModal from '../Modal/ADGMModal';
import styles from './header-jss';
// import CommunicationChannel from './CommunicationChannel';
const { HELP_URL } = FRESH_DESK_URL;
function HeaderMenu(props) {
  // eslint-disable-line
  const {
    classes,
    dataMenu,
    toggleDrawerOpen,
    openMobileNav,
    isLogin,
    userAttr,
    loadTransition,
    logoLink,
    signOut,
    history,
  } = props;
  const [status, setStatus] = useState(dummy.user.status);
  const isGuest = localStorage.getItem('login_with') === 'GuestLogin';
  const [anchorEl, setAnchorEl] = useState(null);
  const isLoginPage = false;
  const [{ tasksForNavbar: tasks }, loading, failure] = useSelector(stateReducer => [stateReducer.tasksListReducer]);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const dispatch = useDispatch();
  const isProduction = useMemo(() => {
    return process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com';
  }, []);

  useEffect(() => {
    if (isLogin) {
      dispatch(
        fetchTask({
          filter: { taskStatus: 'PENDING' },
          id: '',
          page: 0,
          size: !isMobile ? 14 : 10,
          isFetchingNavbarTasks: true,
        }),
      );
    }
  }, []);

  const toggleModal = () => {
    history.push('/login');
  };

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeStatus = newStatus => {
    setStatus(newStatus);
    handleClose();
  };
  const helpHandler = () => {
    CleverTapHeaderHelp();
    window.open(`${HELP_URL}/${localStorage.getItem('lang')}/support/home`, '_blank');
  };
  const appointmentHandler = () => {
    window.open(
      'https://forms.office.com/Pages/ResponsePage.aspx?id=4USxjGDuo02E57afhTdhhK_X4DQpJshMk8cXEgTRBipUMTFCRDM2UVExQVRNVVVSN1Q4RDY3TFBJRC4u',
      '_blank',
    );
  };

  const ProfileHandler = () => {
    history.push('/app/user/profile');
  };
  const loginHandler = () => {
    history.push('/login');
  };
  const { locale } = useSelector(state => state.language);

  const handleLocalToggle = () => {
    if (locale === 'ar') {
      persistStore('en');
      // CleverTapHeaderLanguageSwitch('en');
    } else {
      persistStore('ar');
      // CleverTapHeaderLanguageSwitch('ar');
    }
  };
  const [open, setOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);
  const [menuSelect, setMenuSelect] = useState(null);
  const [topMenuHide, setTopMenuHide] = useState(false);
  const [topDeskTopNav, setDeskTopNav] = useState(false);
  const [bottomNavhHide, setBottomNavhHide] = useState(false);
  useEffect(() => {
    document.body.style.overflow = taskOpen || open ? 'hidden' : 'inherit';
  }, [taskOpen, open]);
  const location = useLocation();
  useEffect(() => {
    const activeUrls = ['/app/directory', '/app/contracts', '/app/market-data-detail'];
    const topMenuHides = [
      '/app/directory',
      '/app/contracts',
      '/app/applications',
      '/app/properties',
      '/app/user/profile',
      '/app/user/primary-contact',
      '/app/user/wallet-and-payments',
      '/app/user/employees',
      '/login',
      '/auth/login-eid',
      '/auth/login-unified',
      '/auth/login-nonUae',
      '/auth/otp',
      '/auth/reset-password',
      '/app/elife-service',
    ];
    const TopDeskTopNavHide = [
      '/login',
      '/auth/login-eid',
      '/auth/login-unified',
      '/auth/login-nonUae',
      '/auth/otp',
      '/auth/reset-password',
    ];
    const BottomNavHide = [
      '/login',
      '/auth/login-eid',
      '/auth/login-unified',
      '/auth/login-nonUae',
      '/auth/otp',
      '/auth/reset-password',
      '/app/elife-service',
    ];
    if (activeUrls.includes(location.pathname)) {
      setMenuSelect('menuSelected');
    } else {
      setMenuSelect(null);
    }

    if (topMenuHides.includes(location.pathname)) {
      setTopMenuHide(false);
    } else {
      setTopMenuHide(true);
    }
    if (BottomNavHide.includes(location.pathname)) {
      setBottomNavhHide(false);
    } else {
      setBottomNavhHide(true);
    }
    if (TopDeskTopNavHide.includes(location.pathname)) {
      setDeskTopNav(false);
    } else {
      setDeskTopNav(true);
    }
    setOpen(false);
    setTaskOpen(false);
  }, [location]);

  const { search } = useLocation();
  const isMobileParam = new URLSearchParams(search).get('mobile');
  return (
    <>
      {/* {!isMobileParam && <SmartBanner />} */}
      {MAINTANANCE_MODE === 1 ? (
        <div className={classes.maintainance}>
          <div className={classes.successImgHolder} style={{ justifyContent: 'flex-start' }}>
            <ADGMImage name='Error.svg' alt='success img' className={classes.successImg} />
            <FormattedMessage {...messages.dmt_downtime_message} />
          </div>
        </div>
      ) : (
        ''
      )}
      {/* <CommunicationChannel /> */}
      {!isMobileParam && (
        <Hidden smUp>
          {topMenuHide && (
            <div className={classNames(classes.mobiletitlehead, isLogin ? classes.withLogin : '')}>
              <ADGMImage name='adgm-logo.svg' alt='logo' />
              <div style={{ display: 'flex' }}>
                {isLogin ? (
                  <>
                    {!isProduction && (
                      <>
                        <Button onClick={handleLocalToggle} variant='text'>
                          {locale === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
                        </Button>
                        <Button
                          className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                          onClick={helpHandler}
                          variant='outlined'
                        >
                          <ADGMImage name={isGuest ? 'help_center_new.svg' : 'help_center_new_black.svg'} />
                        </Button>
                        <Button
                          className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                          onClick={() => setTaskOpen(!taskOpen)}
                        >
                          <ADGMImage name='bell_icon.svg' width='14px' height='14px' />
                        </Button>
                      </>
                    )}
                    <LightTooltipComponent title={keyEmptyCheck('schedule_appointment')}>
                      <Button className={classes.iconButtons} onClick={appointmentHandler} variant='outlined'>
                        <ADGMImage name='appointment_black.svg' />
                      </Button>
                    </LightTooltipComponent>
                    <Button
                      className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                      onClick={ProfileHandler}
                      variant='outlined'
                    >
                      <ADGMImage name='user_logged.svg' />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className={classNames(classes.loginButtonSmall, classes.btnPrimary)}
                      variant='contained'
                      onClick={loginHandler}
                      to={link.login}
                    >
                      <FormattedMessage {...messages.login} />
                    </Button>

                    <Button className={classes.iconButtons} onClick={appointmentHandler} variant='outlined'>
                      <ADGMImage name='appointment_black.svg' />
                    </Button>
                    {!isProduction && (
                      <Button onClick={handleLocalToggle} variant='text'>
                        {locale === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </Hidden>
      )}

      {!isMobileParam && topDeskTopNav && (
        <AppBar
          position='fixed'
          sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
          className={classNames(classes.appBar, classes.attachedBar, isLogin ? classes.withLogin : '')}
        >
          <Container className={classes.container}>
            <div className={classes.appMenu}>
              {/* mobile drawer opener button */}
              <Hidden lgUp>
                <IconButton aria-label='Menu' onClick={toggleDrawerOpen}>
                  <Menu />
                  <ADGMImage name='adgm-logo.svg' className={classes.brandIpad} alt={appContent.name} />
                </IconButton>
              </Hidden>

              <div className={classes.logoHolder}>
                {/* Logo */}
                <Hidden mdDown>
                  <NavLink to={logoLink} className={classes.brand}>
                    <ADGMImage name='adgm-logo.svg' alt={appContent.name} />
                  </NavLink>
                </Hidden>
                {isLogin === true || isGuest === true ? (
                  <Hidden mdDown>
                    <Navigation data={dataMenu} isGuest={isGuest} />
                  </Hidden>
                ) : (
                  ''
                )}
              </div>
              {/* navigation */}
              <Toolbar className={classes.headerNavbar}>
                {isLogin ? (
                  <>
                    <UserMenu signOut={signOut} avatar={userAttr.avatar} name={userAttr.name} />

                    <LightTooltipComponent title={keyEmptyCheck('check_your_tasks')}>
                      <Button
                        onClick={() => setTaskOpen(!taskOpen)}
                        className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                      >
                        <ADGMImage name='bell_icon.svg' />
                      </Button>
                    </LightTooltipComponent>

                    {!isProduction && (
                      <>
                        <Button onClick={handleLocalToggle} variant='text'>
                          {locale === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
                        </Button>
                        <LightTooltipComponent title={keyEmptyCheck('help_support')}>
                          <Button
                            onClick={helpHandler}
                            variant='outlined'
                            className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                          >
                            <ADGMImage name={isGuest ? 'help_center_new.svg' : 'help_center_new_black.svg'} />
                          </Button>
                        </LightTooltipComponent>
                      </>
                    )}

                    <LightTooltipComponent title={keyEmptyCheck('schedule_appointment')}>
                      <Button className={classes.iconButtons} onClick={appointmentHandler} variant='outlined'>
                        <ADGMImage name='appointment_black.svg' />
                      </Button>
                    </LightTooltipComponent>
                  </>
                ) : isLoginPage || isGuest ? (
                  <>
                    <Button
                      className={classNames(classes.loginButton, classes.btnPrimary)}
                      variant='text'
                      onClick={toggleModal}
                      to={link.login}
                    >
                      <FormattedMessage {...messages.login} />
                    </Button>

                    {!isProduction ? (
                      <>
                        <LightTooltipComponent title={keyEmptyCheck('schedule_appointment')}>
                          <Button className={classes.iconButtons} onClick={appointmentHandler} variant='outlined'>
                            <ADGMImage name='appointment_black.svg' />
                          </Button>
                        </LightTooltipComponent>

                        <LightTooltipComponent title={keyEmptyCheck('help_support')}>
                          <Button
                            onClick={helpHandler}
                            variant='outlined'
                            className={isGuest ? classes.iconButtons : classes.iconsButtonBlack}
                          >
                            <ADGMImage name='help_center_new_black.svg' />
                          </Button>
                        </LightTooltipComponent>

                        <Button onClick={handleLocalToggle} variant='text'>
                          {locale === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
                        </Button>
                      </>
                    ) : (
                      <>
                        <LightTooltipComponent title={keyEmptyCheck('help_support')}>
                          <Button className={classes.iconButtons} onClick={appointmentHandler} variant='outlined'>
                            <ADGMImage name='appointment_black.svg' />
                          </Button>
                        </LightTooltipComponent>
                      </>
                    )}
                  </>
                ) : null}
              </Toolbar>

              {/* -- navigation end */}

              <Hidden xlUp>
                <SwipeableDrawer
                  onClose={toggleDrawerOpen}
                  onOpen={toggleDrawerOpen}
                  open={openMobileNav}
                  anchor='left'
                >
                  <div className={classes.swipeDrawerPaper}>
                    <SidebarContent
                      drawerPaper
                      leftSidebar
                      toggleDrawerOpen={toggleDrawerOpen}
                      loadTransition={loadTransition}
                      dataMenu={dataMenu}
                      status={status}
                      anchorEl={anchorEl}
                      openMenuStatus={handleOpen}
                      closeMenuStatus={handleClose}
                      changeStatus={handleChangeStatus}
                      isLogin={isLogin}
                      userAttr={userAttr}
                    />
                  </div>
                </SwipeableDrawer>
              </Hidden>
            </div>
          </Container>
        </AppBar>
      )}

      {!isMobileParam && bottomNavhHide && (
        <>
          <AppBar position='fixed' style={{ zIndex: 1254 }}>
            <BottomNavigation showLabels className={classes.mobileNavigation} value={menuSelect}>
              <BottomNavigationAction
                component={NavLink}
                to='/app/home'
                classes={{ selected: 'active' }}
                label={<FormattedMessage {...messages.home} />}
                onClick={() => CleverTapNavigation('home')}
                icon={
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g>
                      <path
                        d='M11.115 0.694131C10.809 0.418662 10.4118 0.266235 10 0.266235C9.58824 0.266235 9.19105 0.418662 8.885 0.694131L0 8.6908V17.3575C0 18.0647 0.280952 18.743 0.781049 19.2431C1.28115 19.7432 1.95942 20.0241 2.66667 20.0241H17.3333C18.0406 20.0241 18.7189 19.7432 19.219 19.2431C19.719 18.743 20 18.0647 20 17.3575V8.6908L11.115 0.694131ZM12.5 18.355H7.5V14.1666C7.5 13.5036 7.76339 12.8677 8.23223 12.3989C8.70107 11.93 9.33696 11.6666 10 11.6666C10.663 11.6666 11.2989 11.93 11.7678 12.3989C12.2366 12.8677 12.5 13.5036 12.5 14.1666V18.355ZM18.3333 17.355C18.3333 17.6202 18.228 17.8745 18.0404 18.0621C17.8529 18.2496 17.5985 18.355 17.3333 18.355H14.1667V14.1666C14.1667 13.0616 13.7277 12.0018 12.9463 11.2204C12.1649 10.439 11.1051 9.99997 10 9.99997C8.89493 9.99997 7.83512 10.439 7.05372 11.2204C6.27232 12.0018 5.83333 13.0616 5.83333 14.1666V18.355H2.66667C2.40145 18.355 2.1471 18.2496 1.95956 18.0621C1.77202 17.8745 1.66667 17.6202 1.66667 17.355V9.43247L10 1.93246L18.3333 9.43247V17.355Z'
                        fill='#484456'
                      />
                    </g>
                    <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#clip0_3551_786)'>
                      <path
                        d='M10 11.6667C9.33696 11.6667 8.70107 11.9301 8.23223 12.399C7.76339 12.8678 7.5 13.5037 7.5 14.1667V20.0217H12.5V14.1667C12.5 13.5037 12.2366 12.8678 11.7678 12.399C11.2989 11.9301 10.663 11.6667 10 11.6667Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M11.115 0.694253C10.809 0.418784 10.4118 0.266357 10 0.266357C9.58824 0.266357 9.19105 0.418784 8.885 0.694253L0 8.69092V17.3576C0 18.0648 0.280952 18.7431 0.781049 19.2432C1.28115 19.7433 1.95942 20.0243 2.66667 20.0243H5.83333V14.1668C5.83333 13.0617 6.27232 12.0019 7.05372 11.2205C7.83512 10.4391 8.89493 10.0001 10 10.0001C11.1051 10.0001 12.1649 10.4391 12.9463 11.2205C13.7277 12.0019 14.1667 13.0617 14.1667 14.1668V20.0218H17.3333C18.0406 20.0218 18.7189 19.7408 19.219 19.2407C19.719 18.7406 20 18.0623 20 17.3551V8.68842L11.115 0.694253Z'
                        fill='#0088FF'
                      />
                    </g>
                  </svg>
                }
              />
              <BottomNavigationAction
                component={NavLink}
                to='/app/applications'
                classes={{ selected: 'Menuselected' }}
                label={<FormattedMessage {...messages.Applications} />}
                onClick={() => CleverTapNavigation('application')}
                icon={
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_3564_764)'>
                      <path
                        d='M16.5233 2.84501L14.655 0.976678C14.3461 0.666102 13.9787 0.419866 13.5741 0.252222C13.1694 0.0845773 12.7355 -0.00114639 12.2975 1.15766e-05H5C4.33696 1.15766e-05 3.70107 0.263404 3.23223 0.732245C2.76339 1.20109 2.5 1.83697 2.5 2.50001V20H17.5V5.20168C17.4978 4.3181 17.1468 3.47112 16.5233 2.84501ZM15.345 4.02334C15.3869 4.06882 15.4261 4.11667 15.4625 4.16668H13.3333V2.03751C13.3833 2.07388 13.4312 2.11311 13.4767 2.15501L15.345 4.02334ZM4.16667 18.3333V2.50001C4.16667 2.279 4.25446 2.06704 4.41074 1.91076C4.56702 1.75448 4.77899 1.66668 5 1.66668H11.6667V5.83334H15.8333V18.3333H4.16667ZM5.83333 13.3333H14.1667V8.33335H5.83333V13.3333ZM7.5 10H12.5V11.6667H7.5V10ZM5.83333 15H14.1667V16.6667H5.83333V15Z'
                        fill='#484456'
                      />
                    </g>
                    <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#clip0_3572_545)'>
                      <path
                        d='M12.5 11.6667H7.5V10H12.5V11.6667ZM17.5 5.83333V20H2.5V2.5C2.5 1.83696 2.76339 1.20107 3.23223 0.732233C3.70107 0.263392 4.33696 0 5 0L11.6667 0V5.83333H17.5ZM14.1667 15H5.83333V16.6667H14.1667V15ZM14.1667 8.33333H5.83333V13.3333H14.1667V8.33333ZM16.5233 2.845L14.655 0.976667C14.2826 0.612287 13.8299 0.340289 13.3333 0.1825V4.16667H17.3208C17.163 3.66938 16.8897 3.21649 16.5233 2.845Z'
                        fill='#0088FF'
                      />
                    </g>
                  </svg>
                }
              />
              <BottomNavigationAction
                component={NavLink}
                to='/app/services'
                classes={{ selected: 'Menuselected' }}
                label={<FormattedMessage {...messages.Services} />}
                onClick={() => CleverTapNavigation('services')}
                icon={
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_3572_549)'>
                      <path
                        d='M0 2.5V9.16667H9.16667V0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5ZM7.5 7.5H1.66667V2.5C1.66667 2.27899 1.75446 2.06702 1.91074 1.91074C2.06702 1.75446 2.27899 1.66667 2.5 1.66667H7.5V7.5Z'
                        fill='#484456'
                      />
                      <path
                        d='M0 17.4999C0 18.163 0.263392 18.7988 0.732233 19.2677C1.20107 19.7365 1.83696 19.9999 2.5 19.9999H9.16667V10.8333H0V17.4999ZM1.66667 12.4999H7.5V18.3333H2.5C2.27899 18.3333 2.06702 18.2455 1.91074 18.0892C1.75446 17.9329 1.66667 17.7209 1.66667 17.4999V12.4999Z'
                        fill='#484456'
                      />
                      <path
                        d='M10.8334 10.8333V19.9999H17.5C18.1631 19.9999 18.799 19.7365 19.2678 19.2677C19.7366 18.7988 20 18.163 20 17.4999V10.8333H10.8334ZM18.3334 17.4999C18.3334 17.7209 18.2456 17.9329 18.0893 18.0892C17.933 18.2455 17.7211 18.3333 17.5 18.3333H12.5V12.4999H18.3334V17.4999Z'
                        fill='#484456'
                      />
                      <path
                        d='M14.1667 9.16658H15.8334V5.83325H19.1667V4.16659H15.8334V0.833252H14.1667V4.16659H10.8334V5.83325H14.1667V9.16658Z'
                        fill='#484456'
                      />
                    </g>
                    <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#clip0_3572_1247)'>
                      <path
                        d='M0 2.5V9.16667H9.16667V0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M0 17.4999C0 18.163 0.263392 18.7988 0.732233 19.2677C1.20107 19.7365 1.83696 19.9999 2.5 19.9999H9.16667V10.8333H0V17.4999Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M10.8334 10.8333V19.9999H17.5C18.1631 19.9999 18.799 19.7365 19.2678 19.2677C19.7366 18.7988 20 18.163 20 17.4999V10.8333H10.8334Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M14.1667 9.16658H15.8334V5.83325H19.1667V4.16659H15.8334V0.833252H14.1667V4.16659H10.8334V5.83325H14.1667V9.16658Z'
                        fill='#0088FF'
                      />
                    </g>
                  </svg>
                }
              />
              <BottomNavigationAction
                component={NavLink}
                to='/app/properties'
                label={<FormattedMessage {...messages.Properties} />}
                onClick={() => CleverTapNavigation('properties')}
                icon={
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_3572_1254)'>
                      <path
                        d='M12.3742 10.6225L7.83417 7.06833C7.1475 6.53083 6.18667 6.53 5.5 7.06833L0.959167 10.6217C0.35 11.0992 0 11.8175 0 12.5908V20H13.3333V12.5908C13.3333 11.8167 12.9833 11.0992 12.3742 10.6225ZM11.6667 18.3333H1.66667V12.5908C1.66667 12.3325 1.78333 12.0933 1.98667 11.9342L6.52667 8.38167C6.60833 8.31667 6.72333 8.3175 6.80667 8.38167L11.3467 11.9358C11.55 12.0942 11.6667 12.3342 11.6667 12.5917V18.3333ZM5 12.5H8.33333V15.8333H5V12.5ZM15 10.8333H16.6667V12.5H15V10.8333ZM15 14.1667H16.6667V15.8333H15V14.1667ZM11.6667 4.16667H13.3333V5.83333H11.6667V4.16667ZM16.6667 5.83333H15V4.16667H16.6667V5.83333ZM11.6667 7.5H13.3333V9.16667H11.6667V7.5ZM15 7.5H16.6667V9.16667H15V7.5ZM20 2.5V20H15V18.3333H18.3333V2.5C18.3333 2.04 17.96 1.66667 17.5 1.66667H10.8333C10.3733 1.66667 10 2.04 10 2.5V6.64833L8.33333 5.34417V2.5C8.33333 2.48583 8.33333 2.47083 8.33417 2.45667C8.3575 1.09833 9.46917 0 10.8333 0H17.5C18.8783 0 20 1.12167 20 2.5Z'
                        fill='#484456'
                      />
                    </g>
                    <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#clip0_3572_215)'>
                      <path
                        d='M17.5 0H10.8333C9.455 0 8.33333 1.12167 8.33333 2.5V5.41583C8.51583 5.51333 8.6925 5.625 8.86083 5.75667L11.6667 7.95333V7.50083H13.3333V9.2575L13.4008 9.31C14.4175 10.105 15 11.3017 15 12.5917V14.1675H16.6667V15.8342H15V20.0008H20V2.5C20 1.12167 18.8783 0 17.5 0ZM13.3333 5.83333H11.6667V4.16667H13.3333V5.83333ZM16.6667 12.5H15V10.8333H16.6667V12.5ZM16.6667 9.16667H15V7.5H16.6667V9.16667ZM16.6667 5.83333H15V4.16667H16.6667V5.83333ZM12.3742 10.6225L7.83417 7.06833C7.1475 6.53083 6.18667 6.53 5.5 7.06833L0.959167 10.6217C0.35 11.0992 0 11.8175 0 12.5908V20H13.3333V12.5908C13.3333 11.8167 12.9833 11.0992 12.3742 10.6225ZM8.33333 15.8333H5V12.5H8.33333V15.8333Z'
                        fill='#0088FF'
                      />
                    </g>
                  </svg>
                }
              />
              <BottomNavigationAction
                label={keyEmptyCheck('menu')}
                value='menuSelected'
                onClick={() => {
                  CleverTapNavigation('Menu');
                  setOpen(!open);
                }}
                classes={{ selected: 'active' }}
                icon={
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_3564_807)'>
                      <path
                        d='M19.1667 9.16675H0.833333C0.373096 9.16675 0 9.53984 0 10.0001C0 10.4603 0.373096 10.8334 0.833333 10.8334H19.1667C19.6269 10.8334 20 10.4603 20 10.0001C20 9.53984 19.6269 9.16675 19.1667 9.16675Z'
                        fill='#484456'
                      />
                      <path
                        d='M19.1667 3.33325H0.833333C0.373096 3.33325 0 3.70635 0 4.16659C0 4.62682 0.373096 4.99992 0.833333 4.99992H19.1667C19.6269 4.99992 20 4.62682 20 4.16659C20 3.70635 19.6269 3.33325 19.1667 3.33325Z'
                        fill='#484456'
                      />
                      <path
                        d='M19.1667 15H0.833333C0.373096 15 0 15.3731 0 15.8333C0 16.2936 0.373096 16.6667 0.833333 16.6667H19.1667C19.6269 16.6667 20 16.2936 20 15.8333C20 15.3731 19.6269 15 19.1667 15Z'
                        fill='#484456'
                      />
                    </g>
                    <g>
                      <path
                        d='M18.75 6.75H1.25C0.559648 6.75 0 7.30965 0 8C0 8.69035 0.559648 9.25 1.25 9.25H18.75C19.4404 9.25 20 8.69035 20 8C20 7.30965 19.4404 6.75 18.75 6.75Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M1.25 3.41675H18.75C19.4404 3.41675 20 2.8571 20 2.16675C20 1.4764 19.4404 0.916748 18.75 0.916748H1.25C0.559648 0.916748 0 1.4764 0 2.16675C0 2.8571 0.559648 3.41675 1.25 3.41675Z'
                        fill='#0088FF'
                      />
                      <path
                        d='M18.75 12.5835H1.25C0.559648 12.5835 0 13.1431 0 13.8335C0 14.5238 0.559648 15.0835 1.25 15.0835H18.75C19.4404 15.0835 20 14.5238 20 13.8335C20 13.1431 19.4404 12.5835 18.75 12.5835Z'
                        fill='#0088FF'
                      />
                    </g>
                  </svg>
                }
              />
            </BottomNavigation>
          </AppBar>
        </>
      )}

      {/* task notification popup */}
      <div className={classNames(classes.staticDrawer, taskOpen && classes.staticOpen)}>
        <div className={classes.gradientColor} onClick={() => setTaskOpen(!taskOpen)} aria-hidden='true' />
        <div className={classes.content}>
          <TaskList
            tasks={tasks?.data}
            locale={locale}
            loading={loading}
            failure={failure}
            tasksTotal={tasks?.totalRecord}
            handleClose={() => setTaskOpen(!taskOpen)}
          />
        </div>
      </div>
      {/* more popup for phone */}
      <Hidden smUp>
        <div className={classNames(classes.staticDrawer, open && classes.staticOpen, classes.morePopup)}>
          <div className={classes.content}>
            <MoreMenu />
          </div>
        </div>
      </Hidden>
    </>
  );
}

HeaderMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  dataMenu: PropTypes.array.isRequired,
  openMobileNav: PropTypes.bool.isRequired,
  userAttr: PropTypes.object.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
  loadTransition: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  logoLink: PropTypes.string,
  isLogin: PropTypes.bool,
};

HeaderMenu.defaultProps = {
  isLogin: false,
  logoLink: '/',
};

export default withStyles(styles)(injectIntl(HeaderMenu));
